import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var markIsLoggingEnabledDirty = mutatorAction('markIsLoggingEnabledDirty', function (isDirty) {
    var store = mobileDeviceFullStore();
    store.isLoggingEnabledDirty = isDirty;
});
//# sourceMappingURL=markIsLoggingEnabledDirty.js.map